import { Grid2, Skeleton } from "@mui/material";
import { grey } from "@mui/material/colors";

export default function OrderChatSkeleton() {

    return (
        <Grid2 container flexDirection={'column'} gap={1}>
            {Array.from({ length: 3 }).map((_, i) => (
                <Grid2 key={i} container justifyContent={i % 2 === 0 ? 'start' : 'end'}>
                    <Grid2 container flexDirection={i % 2 === 0 ? 'row' : 'row-reverse'} gap={1}>
                        <Grid2>
                            <Skeleton variant="circular" width={50} height={50} />
                        </Grid2>
                        <Grid2 container flexDirection={'column'} sx={{ backgroundColor: 'rgba(0,0,0,0.05)', borderRadius: 4 }} padding={2}>
                            <Grid2>
                                <Skeleton variant="text" width={100} />
                            </Grid2>
                            <Grid2>
                                <Skeleton variant="text" width={75} />
                            </Grid2>
                            <Grid2>
                                <Skeleton variant="text" width={100} />
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Grid2>
            ))}
        </Grid2>
    )
}